import React from 'react';
import { formatDate } from '../../Utilities/GridTools';
import ReportTemplateCSVClick from '../ReportTemplateCSVClick';

const ArbUnassigned = () => {
    const columnDefs = [
        { headerName: 'Debtor ID', field: 'debtorid' },
        { headerName: 'Claim ID', field: 'clientRefNo' },
        { headerName: 'Client', field: 'client' },
        { headerName: 'Loss State', field: 'stateOfLoss' },
        { headerName: 'Service Date', field: 'serviceDate', valueFormatter: formatDate, filter: 'agDateColumnFilter' },
        { headerName: 'List Date', field: 'listDate', valueFormatter: formatDate, filter: 'agDateColumnFilter' },
        { headerName: 'Account Status', field: 'accountStatus' },
        { headerName: 'Debtor Status', field: 'debtorStatus' },
        { headerName: 'Project ID', field: 'projectID' },
        { headerName: 'Filed By', field: 'arbFiledBy' },
        { headerName: 'Project', field: 'projectID' },
        { headerName: 'Hearing Date', field: 'arbHearingDate', valueFormatter: formatDate, filter: 'agDateColumnFilter' },
        { headerName: 'Docket', field: 'arbDocketNumber' },
        { headerName: 'Entered By', field: 'enteredBy' },
        { headerName: 'Principle', field: 'principle' }
    ];

    const apiUrl = `${process.env.REACT_APP_API_URL}/Reports/Arb/ArbOpenUnassigned`;

    return (
        <ReportTemplateCSVClick columnDefs={columnDefs} apiUrl={apiUrl} reportName={'Arb Unassigned'} />
    );
};

export default ArbUnassigned;